/**
 * Zenvelo Gift-with-Purchase
 * Voegt gratis gifts toe bij ATC. Gebruikt dezelfde aanpak als Dawn's product-form.js.
 */

(function () {
  'use strict';

  const cfg = document.getElementById('zenvelo-gift-config');
  if (!cfg) return;

  const MAIN_VARIANT  = parseInt(cfg.dataset.mainVariant, 10);
  const GIFT_VARIANTS = (cfg.dataset.giftVariants || '')
    .split(',')
    .map(s => parseInt(s.trim(), 10))
    .filter(n => n > 0);

  if (!MAIN_VARIANT || !GIFT_VARIANTS.length) return;

  const PROP_KEY = '_zenvelo_gift';
  const PROP_VAL = 'true';
  let   busy     = false;

  /* ── Helpers ──────────────────────────────────────────────────────────── */

  function fetchCart() {
    return fetch(window.Shopify ? '/cart.js' : '/cart.js').then(r => r.json());
  }

  function cartAddJSON(items) {
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ items }),
    }).then(r => r.json());
  }

  function cartUpdate(updates) {
    return fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ updates }),
    }).then(r => r.json());
  }

  /* Voeg hoofdproduct toe via FormData (zelfde als Dawn) + sections voor drawer HTML */
  function cartAddMain(variantId, qty, cartDrawer) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', qty);
    if (cartDrawer) {
      cartDrawer.getSectionsToRender().forEach(s => formData.append('sections', s.id));
      formData.append('sections_url', window.location.pathname);
    }
    return fetch('/cart/add', {
      method:  'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body:    formData,
    }).then(r => r.json());
  }

  /* Haal verse drawer-HTML op na gift-toevoeging */
  function fetchSections(cartDrawer) {
    const ids = cartDrawer.getSectionsToRender().map(s => s.id).join(',');
    return fetch(`/cart?sections=${ids}&sections_url=${encodeURIComponent(window.location.pathname)}`)
      .then(r => r.json());
  }

  function openDrawer(sectionsData, triggerEl, cartDrawer) {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.setActiveElement === 'function' && triggerEl) {
      cartDrawer.setActiveElement(triggerEl);
    }
    cartDrawer.renderContents(sectionsData);
  }

  /* ── Hoofd-flow ───────────────────────────────────────────────────────── */

  async function addToCartWithGifts(submitBtn) {
    if (busy) return;
    busy = true;

    const cartDrawer = document.querySelector('cart-drawer');

    try {
      /* 1. Voeg hoofdproduct toe (FormData → sections in response) */
      const addResponse = await cartAddMain(MAIN_VARIANT, 1, cartDrawer);

      if (addResponse.status) {
        /* Shopify-fout (bijv. uitverkocht) */
        console.warn('[Zenvelo GWP] cart/add fout:', addResponse.description || addResponse);
        busy = false;
        return;
      }

      /* 2. Check welke gifts al in cart zitten */
      const cart = await fetchCart();
      const existingGiftVariants = cart.items
        .filter(i => i.properties && i.properties[PROP_KEY] === PROP_VAL)
        .map(i => i.variant_id);

      const missing = GIFT_VARIANTS.filter(id => !existingGiftVariants.includes(id));

      /* 3. Voeg ontbrekende gifts toe (JSON, geen drawer-open nodig) */
      if (missing.length > 0) {
        await cartAddJSON(missing.map(id => ({
          id,
          quantity:   1,
          properties: { [PROP_KEY]: PROP_VAL },
        })));
      }

      /* 4. Open cart UI — drawer (Dawn native) of derde-partij app */
      if (cartDrawer) {
        if (missing.length > 0) {
          const sections = await fetchSections(cartDrawer);
          openDrawer(sections, submitBtn, cartDrawer);
        } else if (addResponse.sections) {
          openDrawer(addResponse, submitBtn, cartDrawer);
        } else {
          const sections = await fetchSections(cartDrawer);
          openDrawer(sections, submitBtn, cartDrawer);
        }
      } else {
        /* Geen native cart-drawer aanwezig: trigger derde-partij cart apps
           (AMP Slide Cart, etc.) via standaard events */
        document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent('cart:open',    { bubbles: true }));
        /* Dawn pub/sub → cart-notification / cart icon count */
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: addResponse });
        }
      }

    } catch (err) {
      console.error('[Zenvelo GWP] fout:', err);
      /* Fallback: stuur de form gewoon in als page-redirect */
      if (submitBtn) {
        const form = submitBtn.closest('form');
        if (form) {
          /* Verwijder onze event-listener tijdelijk en submit normaal */
          form.dataset.zenveloGwpBound = '';
          form.submit();
        }
      }
    } finally {
      busy = false;
    }
  }

  /* ── Form interceptie ─────────────────────────────────────────────────── */

  function interceptForm(form) {
    if (form.dataset.zenveloGwpBound === 'true') return;
    form.dataset.zenveloGwpBound = 'true';

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }

      await addToCartWithGifts(btn);

      if (btn) {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
      }
    }, { capture: true });
  }

  function bindForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(interceptForm);
  }

  bindForms();
  new MutationObserver(bindForms).observe(document.body, { childList: true, subtree: true });

  /* ── Gifts verwijderen als hoofdproduct weg is ────────────────────────── */

  async function syncGifts() {
    try {
      const cart = await fetchCart();
      const hasMain = cart.items.some(i => i.variant_id === MAIN_VARIANT);
      const gifts   = cart.items.filter(i => i.properties && i.properties[PROP_KEY] === PROP_VAL);

      if (!hasMain && gifts.length > 0) {
        const updates = {};
        gifts.forEach(i => { updates[i.key] = 0; });
        await cartUpdate(updates);

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          const sections = await fetchSections(drawer);
          drawer.renderContents(sections);
        }
      }
    } catch (err) {
      console.warn('[Zenvelo GWP] syncGifts fout:', err);
    }
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'zenvelo-gwp') return;
      syncGifts();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button')) {
      setTimeout(syncGifts, 800);
    }
  });

})();
